import React from 'react'
import CookieConsent from 'react-cookie-consent'
import useWindowSize from 'styles/window-size'

import { Wrapper, Content, LinkItem } from './index.styled'

const CookiesBanner = () => {
  const ref = React.useRef()
  const { width } = useWindowSize()

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, 6000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <Wrapper ref={ref}>
      <CookieConsent
        location='none'
        buttonText='Accept All'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
        // debug={true}
      >
        <Content>
          {width >= 768
            ? (
              <>
                We use cookies to improve your experience.<br /> By using this website you agree to our <LinkItem href='https://www.cookiesandyou.com' target='_blank'>Cookie Policy</LinkItem>.
              </>
              )
            : (
              <>
                This website uses <LinkItem href='https://www.cookiesandyou.com' target='_blank'>cookies</LinkItem>.
              </>
              )}
        </Content>
      </CookieConsent>
    </Wrapper>
  )
}
export default CookiesBanner
